import * as yup from "yup";

import { ICreateTransferPin } from "../../interfaces-and-types";

export const createTransferPinSchema: yup.SchemaOf<ICreateTransferPin> = yup
  .object({
    password: yup.string().required("Password is required"),
    pin: yup
      .string()
      .min(4, "PIN is too short. Minimum is 4 digits")
      .required("PIN is required"),
    confirm_pin: yup
      .string()
      .oneOf([yup.ref("pin"), null], "Pin and confirmation must match")
      .required("PIN confirmation is required"),
  })
  .required();
